import React, { useState, useEffect } from "react";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import classNames from "classnames";
import { getType } from "../../utils/obj-utils";

const BodyText = ({ className, html, tagName, onClick }) => {
  let tag = tagName || "div";
  const type = getType(html);
  const rootClass = classNames("body", className);
  if (type === "[object Object]") {
    return <RichText className={rootClass} tag={tag} field={html} onClick={onClick} />;
  } else if (type === "[object String]") {
    return React.createElement(tag, { className: rootClass, onClick: onClick }, <span dangerouslySetInnerHTML={{ __html: html }} />);
  } else {
    return null;
  }
};

export default BodyText;
